export default __webpack_public_path__ + "assets/images/669f53b79b0ad4768ae2eeabc66eb127.jpg";